// extracted by mini-css-extract-plugin
export default {"button":"language-toggle-module_button-cMCwQ"};